module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buttonsblock"
  }, [_c('FilterButton', {
    attrs: {
      "isActive": _vm.isRoomsType
    },
    on: {
      "selectedType": function($event) {
        return _vm.selectedType('rooms')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }), _vm._v("Вебинар")], 1), _c('FilterButton', {
    attrs: {
      "isActive": _vm.isLessonsType
    },
    on: {
      "selectedType": function($event) {
        return _vm.selectedType('lessons')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "icon",
      "type": "lessons"
    },
    slot: "icon"
  }), _vm._v("Урок")], 1), _c('FilterButton', {
    attrs: {
      "isActive": _vm.isTestsType
    },
    on: {
      "selectedType": function($event) {
        return _vm.selectedType('tests')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "icon",
      "type": "tests"
    },
    slot: "icon"
  }), _vm._v("Задания")], 1), _c('FilterButton', {
    attrs: {
      "isActive": _vm.isExaminationType
    },
    on: {
      "selectedType": function($event) {
        return _vm.selectedType('examination')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "icon",
      "type": "examination"
    },
    slot: "icon"
  }), _vm._v("Тесты")], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34942c47","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/calendar/components/calendarfilter/components/filterbottonsblock/FilterBottonsBlock.vue
// module id = 87a6c5a9d2a12133348f
// module chunks = 7